import React from 'react';
import Navbar from "../../Components/NavBar/index";
import Footer from "../../Components/Footer/index";
import Body from "../../Components/PrivacyPolicy/index";
import SEO from "../../Components/SEO/index";

const Index = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <SEO pageName="privacypolicy" />
      <Navbar />
      <main className="flex-grow bg-gray-100">
        <Body />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
